import usePrev from 'hooks/usePrevious';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

const ScrollToTop = () => {
  const location = useLocation();
  const prevProps = usePrev(location);

  useEffect(() => {
    if (location.pathname !== prevProps?.pathname) {
      if (
        location.state?.noscroll === true ||
        prevProps?.state?.noscroll === true
      )
        return;
      try {
        const container = document.getElementById('page-wrapper');
        if (container) {
          container.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
      } catch (e) {
        window.scrollTo(0, 0);
      }
    }
  }, [location]);

  return null;
};

export default ScrollToTop;
